<section class="flex title gap-8" [class.not-started]="vm.stepNotStarted">
  <div class="index heading-5" [class.dot]="vm.activeStep">
    @if (!vm.activeStep) {
      {{ vm.index }}
    }
  </div>

  <h3 class="heading-5">
    {{ nameMapping[vm.sectionTitle] || vm.sectionTitle }}
  </h3>

  @if (vm.canEdit) {
    <app-button
      dataLabel="edit-button"
      class="ml-auto"
      [buttonOptions]="{
        variant: 'link',
      }"
      (onClick)="resumeStep.emit()"
    >
      <span class="link-text large"> Edit </span>
      <i class="fa-light fa-edit ml-8"></i>
    </app-button>
  }
</section>

@if (vm.isStepBehindCurrentStep) {
  <section class="step mt-8 pl-4 flex-col">
    @for (step of vm.stepValues; track step.type) {
      <section class="flex">
        <p class="body">
          <i class="fa-light mr-12 mt-4 fa-check"></i>
          @switch (step.type) {
            @case ('DATE') {
              {{ step.value | date: 'dd MMM yyyy' }}
            }

            @default {
              {{ step.value }}
            }
          }
        </p>
      </section>
    }
  </section>
}
